module.exports = __webpack_public_path__ + "fonts/3107C8_6_0.9eb64c4.woff2";